// extracted by mini-css-extract-plugin
export default {"ingredient":"ingredient-details_ingredient__5fSHd","nutrients":"ingredient-details_nutrients__q6jWm"};